import { head } from '../../../../../utils/helper/lodash_replacements';
import { runtime } from '../../../../../classes/runtime/Runtime';
export class OrderedTaskStepState {
    parent;
    constructor(parent) {
        this.parent = parent;
    }
    get step() {
        return this.parent;
    }
    get task() {
        return this.step.task;
    }
    get selectedOptionIndicies() {
        const answer = this.task.question.parent;
        if (answer instanceof runtime.class.Answer) {
            if (answer.answerAttributes.evaltext_stored.length > 0) {
                const steps = answer.answerAttributes.evaltext_stored.split(';');
                const stepString = steps[this.step.itemIndex];
                return stepString.split(',').map((s) => parseInt(s));
            }
        }
        return this.step.selectionEvents.map((event) => event.eventAspect.aspect.parent.optionIndex);
    }
    get selectedOptions() {
        return this.selectedOptionIndicies.map((index) => this.task.options[index]);
    }
    get latestSelectionEvent() {
        return head(this.step.selectionEvents);
    }
    get latestSelectedOption() {
        return head(this.selectedOptions);
    }
}
